import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function ProfessionSummaryCard({ insuranceRequest, customer, modificaDati }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const contraente = customer.gender !== 'G'
    ? `${customer.name} ${customer.surname}`
    : customer.business_name;

  const residenza = `${customer.province.name}, ${customer.province.car_plate_symbol}`;

  return (
    <Card>
      <Header>
        <Title>Professionale</Title>
        {modificaDati && (
          <ModificaButton type="button" onClick={modificaDati}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {insuranceRequest.profession.profession_desc}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli professione"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>{contraente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Professione</dt>
              <dd>{insuranceRequest.profession.profession_desc}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Residenza</dt>
              <dd>{residenza}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default ProfessionSummaryCard;
